// extracted by mini-css-extract-plugin
module.exports = {"postCard":"PostCard_postCard__38FPv","postCardImage":"PostCard_postCardImage__2BfXb","postCardTitle":"PostCard_postCardTitle__zjVhN"};